import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent, PageService, PageType } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-content-page-hero-banner',
    templateUrl: './block-content-page-hero-banner.component.html',
    styleUrl: './block-content-page-hero-banner.component.scss',
    standalone: false,
})
export class BlockContentPageHeroBannerComponent extends BlockAbstractComponent implements OnInit {
    hasHeading!: boolean;
    splitLayout!: boolean;
    pageName!: string;
    pageDescription!: string;
    protected override pages: PageService | undefined;

    override ngOnInit() {
        super.ngOnInit();

        this.hasHeading = this.block.data.heading || this.block.data.headingTop || this.block.data.headingBottom;
        const sub = this.pages?.currentPage$?.subscribe((page: PageType) => {
            if (page) {
                this.pageName = page.name;
                this.pageDescription = page.description;
            }
        });
        if (sub) this.subscriptions.push(sub);
    }

    getBackground() {
        if (this.block.data.useBgImage) {
            return `url(${this.block.data.image})`;
        }

        switch (this.block.data.bgFillColor) {
            case 'white':
                return 'white';

            case 'primary':
                return 'var(--color-primary)';

            case 'secondary':
                return 'var(--color-secondary)';

            case 'gradient':
                return `linear-gradient(${this.block.data.bgLinearGradient})`;
        }

        return 'white';
    }
}
